// components/cryptoMarquee/CryptoMarquee.tsx
"use client";

import React, { useEffect, useState } from "react";
import "./style.css";

interface Coin {
  id: string;
  symbol: string;
  name: string;
  image: string;
  current_price: number;
  price_change_percentage_24h: number;
}

const COIN_IDS =
  "bitcoin,tether,binancecoin,usd-coin,ripple,solana,cardano,dogecoin,polygon,polkadot,tron,litecoin";

const CryptoMarquee = ({
  isDark,
  initialCoins = [],
}: {
  isDark: boolean;
  initialCoins?: Coin[];
}) => {
  const [coins, setCoins] = useState<Coin[]>(initialCoins);

  useEffect(() => {
    // Skip first client fetch if SSR already gave us data
    if (initialCoins.length > 0 && coins === initialCoins) return;

    const fetchData = async () => {
      try {
        const res = await fetch(`/api/crypto-marquee?ids=${COIN_IDS}`);
        const data = await res.json();
        if (Array.isArray(data)) setCoins(data);
      } catch (err) {
        console.error(err);
      }
    };

    const interval = setInterval(fetchData, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`marquee ${isDark ? "dark" : ""}`}>
      <div className="marquee-track">
        {[...coins, ...coins].map((coin, i) => {
          const positive = coin.price_change_percentage_24h >= 0;
          return (
            <div className="marquee-item" key={i}>
              <img src={coin.image} alt={coin.name} />
              <span>{coin.symbol.toUpperCase()}</span>
              <span>
                ${coin.current_price.toLocaleString("en-US", { maximumFractionDigits: 4 })}
              </span>
              <span style={{ color: positive ? "#16a34a" : "#ef4444" }}>
                {positive ? "▲" : "▼"} {coin.price_change_percentage_24h.toFixed(2)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CryptoMarquee;